// @flow
import Cookies from "js-cookie"
import { Record, Map, fromJS } from "immutable"

import RESULTS_VIEW_TYPES from "common/consts/resultViewTypes"
import constants from "../consts/config"

const Options = Record({
  affiliateThisSession: "", // query based
  affiliate: "", // cookies based
  affiliateConfig: null,
  apiUrl: constants.apiUrl,
  metaApiUrl: constants.metaApiUrl,
  umbrellaUrl: constants.umbrellaUrl,
  authApiUrl: constants.authApiUrl,
  bookingApiUrl: constants.bookingApiUrl,
  piciApiUrl: constants.piciApiUrl,
  mmbApiUrl: constants.bookingApiUrl,
  priceAlertUrl: constants.priceAlertUrl,
  locationsApiUrl: constants.locationsApiUrl,
  graphqlApiUrl: constants.graphqlApiUrl,
  ancillariesApiUrl: constants.ancillariesApiUrl,
  translationUrl: null,
  preferredResultsView: RESULTS_VIEW_TYPES.AUTO, // TODO move to separate reducer
  country: "",
  previousCurrency: null,
  currency: "eur",
  geo: Map(),
  ui: "default",
  branding: null,
  language: "en",
  browserLanguage: null,
  showTranslationKeys: false,
  showSmartFillOptions: false,
  enableHiddenFeatures: false,
  showConsoleLogs: false,
  showReduxLogs: false,
  debugUmbrella: false,
  simpleABVersions: Map(),
  showMobileAd: false,
  disableServices: "",
  enableServices: "",
  isRootPage: false,
  // TODO refactor to have it only in wowair module
  wowairRequestDate: false,
  wowairRequestDirection: "",
  isAutomatedTest: false,
  isIframeSubdomain: false,
  userId: "",
  customerVerified: false,
  fakeCuckoo: false,
  paymentMethodType: "default",
  trackingIframeVisible: false,
  apiKey: "",
})

// $FlowFixMe
export function optionsFromPlainJS(plain) {
  const lat = parseFloat(plain.geo.lat)
  const lng = parseFloat(plain.geo.lng)

  return new Options({
    ...plain,
    showReduxLogs: Cookies.get("showReduxLogs") === "true" || false,
    debugUmbrella: Cookies.get("debugUmbrella") === "true" || false,
    showConsoleLogs: Cookies.get("showConsoleLogs") === "true" || false,
    fakeCuckoo: Cookies.get("debug_fakeCuckoo") === "true" || false,
    paymentMethodType: Cookies.get("paymentMethodType") || "default",
    branding: fromJS(plain.branding),
    geo: fromJS(plain.geo).merge({
      lat: !isNaN(lat) ? lat : plain.geo.lat,
      lng: !isNaN(lng) ? lng : plain.geo.lng,
    }),
    simpleABVersions: fromJS(plain.simpleABVersions),
  })
}

export default Options
